
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portfolio/audinor",
      function () {
        return require("private-next-pages/portfolio/audinor.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portfolio/audinor"])
      });
    }
  